import React from 'react'

export default function RedoxLogo(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  return <img {...props} src={require('./img/logo-dark.svg')} alt="Redox Logo" />
}
